import { Button } from 'antd';
import React from 'react';
import { Link } from 'react-router-dom';
import './Signup.styles.scss';

export const SignupPage = () => {
  return (
    <div className="signup_wrapper">
      <div className="container-fluid vh-100 px-0">
        <div className="d-flex flex-wrap align-items-center">
          <div className="col-md-6 px-0">
            <div className="signup_wrapper_poster">
              {/* <img src="https://via.placeholder.com/500x750" alt="Signup Poster" /> */}
              <img src="/images/common/flynt-creator-posters.jpg"
                alt="Signin Poster" />
            </div>
          </div>
          <div className="col-md-6">
            <div className="signup_wrapper_formarea py-3">
              <div className="signup_wrapper_content">
                <h4>Brand or Agency ?</h4>
                <p>Sign up to create a branded campaign to reach your intended audience.</p>
                <Link to="/signup/brand-agency">
                  <Button
                    // type="primary"
                    className="common_button"
                    size="large"
                    shape="round">Sign up</Button>
                </Link>
                <span className="pl-3 signup_wrapper_content--ext">Existing member?</span>
                <Link to="/signin/brand-agency">
                  <Button
                    className="px-1"
                    type="link"
                  >Sign in</Button>
                </Link>
              </div>
              <div className="signup_wrapper_content">
                <hr className="mt-4"/>
                <h4>Creator?</h4>
                <p>A bright future together starts here. Sign up to get access to exclusive campaigns.</p>
                <Link to="/signup/influencer">
                  <Button
                    // type="primary"
                    className="common_button"
                    size="large"
                    shape="round">Sign up</Button>
                </Link>
                <span className="pl-3 signup_wrapper_content--ext">Existing member?</span>
                <Link to="/signin/influencer">
                  <Button
                    className="px-1"
                    type="link"
                  >Sign in</Button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
